export async function csrfFetch(url: RequestInfo | URL, options: RequestInit) {
  const meta = document.querySelector<HTMLMetaElement>(
    'meta[name="csrf-token"]'
  )
  const response = await fetch(url, {
    ...options,
    headers: { ...options.headers, "X-CSRF-Token": meta?.content || "" },
  })
  const token = response.headers.get("X-CSRF-Token")
  if (token && meta) meta.content = token
  return response
}
